'use strict';

var _AuthLabelMap, _AuthValueMap;
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
// AuthValue 类型来源：https://github.com/postmanlabs/postman-runtime/blob/466fda18fc/lib/authorizer/index.js

var LegacySecuritySchemeAuthType = 'Security Scheme';
var AuthValue = /*#__PURE__*/function (AuthValue) {
  AuthValue["InHerit"] = "inherit";
  // 当 type === undefined 的时候默认也是继承于父级
  AuthValue["NoAuth"] = "noauth";
  AuthValue["APIKey"] = "apikey";
  AuthValue["BearerToken"] = "bearer";
  AuthValue["BasicAuth"] = "basic";
  AuthValue["DigestAuth"] = "digest";
  AuthValue["OAuth1"] = "oauth1";
  AuthValue["OAuth2"] = "oauth2";
  AuthValue["Hawk"] = "hawk";
  AuthValue["AWS"] = "awsv4";
  AuthValue["NTLM"] = "ntlm";
  AuthValue["EdgeGrid"] = "edgegrid";
  AuthValue["JWT"] = "jwt";
  AuthValue["Kerberos"] = "kerberos1";
  // auth method name in @tarslib/runtime is 'kerberos1'
  AuthValue["SecurityScheme"] = "securityscheme";
  AuthValue["Combination"] = "combination";
  return AuthValue;
}({});
var AuthValueList = Object.values(AuthValue);
var AuthLabelMap = (_AuthLabelMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_AuthLabelMap, AuthValue.InHerit, 'Inherit Parent'), AuthValue.NoAuth, 'No Auth'), AuthValue.APIKey, 'API Key'), AuthValue.BearerToken, 'Bearer Token'), AuthValue.JWT, 'JWT Bearer'), AuthValue.BasicAuth, 'Basic Auth'), AuthValue.DigestAuth, 'Digest Auth'), AuthValue.OAuth1, 'OAuth 1.0'), AuthValue.OAuth2, 'OAuth 2.0'), AuthValue.Hawk, 'Hawk Authentication'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_AuthLabelMap, AuthValue.AWS, 'AWS Signature'), AuthValue.NTLM, 'NTLM Authentication'), AuthValue.EdgeGrid, 'Akamai EdgeGrid'), AuthValue.Kerberos, 'Kerberos'), AuthValue.SecurityScheme, 'Security Scheme'), AuthValue.Combination, 'Combination'), "customize", 'Customize'));
var AuthTypeItemLabelMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, AuthValue.APIKey, {
  key: 'Key',
  value: 'Value'
}), AuthValue.BearerToken, {
  token: 'Token'
}), AuthValue.BasicAuth, {
  username: 'Username',
  password: 'Password'
}), AuthValue.DigestAuth, {
  username: 'Username',
  password: 'Password',
  realm: 'Realm',
  nonce: 'Nonce',
  algorithm: 'Algorithm',
  qop: 'qop',
  nonceCount: 'Nonce Count',
  clientNonce: 'Client Nonce',
  opaque: 'Opaque'
}), AuthValue.OAuth1, {
  "in": 'Add to',
  signatureMethod: 'Signature Method',
  consumerKey: 'Consumer Key',
  consumerSecret: 'Consumer Secret',
  token: 'Access Token',
  tokenSecret: 'Token Secret',
  privateKey: 'Private Key',
  callback: 'Callback URL',
  verifier: 'Verifier',
  timestamp: 'Timestamp',
  nonce: 'Nonce',
  version: 'Version',
  realm: 'Realm'
}), AuthValue.Hawk, {
  authId: 'Hawk Auth ID',
  authKey: 'Hawk Auth Key',
  algorithm: 'Algorithm',
  nonce: 'Nonce',
  timestamp: 'Timestamp',
  extraData: 'ext',
  app: 'app',
  delegation: 'dlg',
  user: 'User'
}), AuthValue.AWS, {
  accessKey: 'AccessKey',
  secretKey: 'SecretKey',
  region: 'AWS Region',
  service: 'Service Name',
  sessionToken: 'Session Token'
}), AuthValue.NTLM, {
  username: 'Username',
  password: 'Password',
  domain: 'Domain',
  workstation: 'Workstation'
}), AuthValue.EdgeGrid, {
  accessToken: 'Access Token',
  clientToken: 'Client Token',
  clientSecret: 'Client Secret',
  nonce: 'Nonce',
  timestamp: 'Timestamp',
  baseURL: 'Base URL',
  headersToSign: 'Headers to sign'
}), AuthValue.Kerberos, {
  service: 'SPN'
});
var AuthValueMap = (_AuthValueMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_AuthValueMap, AuthValue.NoAuth, {
  value: AuthValue.NoAuth,
  label: AuthLabelMap[AuthValue.NoAuth]
}), AuthValue.APIKey, {
  value: AuthValue.APIKey,
  label: AuthLabelMap[AuthValue.APIKey]
}), AuthValue.BearerToken, {
  value: AuthValue.BearerToken,
  label: AuthLabelMap[AuthValue.BearerToken]
}), AuthValue.JWT, {
  value: AuthValue.JWT,
  label: AuthLabelMap[AuthValue.JWT]
}), AuthValue.BasicAuth, {
  value: AuthValue.BasicAuth,
  label: AuthLabelMap[AuthValue.BasicAuth]
}), AuthValue.DigestAuth, {
  value: AuthValue.DigestAuth,
  label: AuthLabelMap[AuthValue.DigestAuth]
}), AuthValue.OAuth2, {
  value: AuthValue.OAuth2,
  label: AuthLabelMap[AuthValue.OAuth2]
}), AuthValue.OAuth1, {
  value: AuthValue.OAuth1,
  label: AuthLabelMap[AuthValue.OAuth1]
}), AuthValue.Hawk, {
  value: AuthValue.Hawk,
  label: AuthLabelMap[AuthValue.Hawk]
}), AuthValue.AWS, {
  value: AuthValue.AWS,
  label: AuthLabelMap[AuthValue.AWS]
}), _defineProperty(_defineProperty(_defineProperty(_AuthValueMap, AuthValue.Kerberos, {
  value: AuthValue.Kerberos,
  label: AuthLabelMap[AuthValue.Kerberos]
}), AuthValue.NTLM, {
  value: AuthValue.NTLM,
  label: AuthLabelMap[AuthValue.NTLM]
}), AuthValue.EdgeGrid, {
  value: AuthValue.EdgeGrid,
  label: AuthLabelMap[AuthValue.EdgeGrid]
}));
var AuthOptionList = Object.values(AuthValueMap);
var InheritAuthOption = {
  value: AuthValue.InHerit,
  label: AuthLabelMap[AuthValue.InHerit]
};
var defaultAuth = {
  type: InheritAuthOption.value
};
var Algorithm = /*#__PURE__*/function (Algorithm) {
  Algorithm["MD5"] = "MD5";
  Algorithm["MD5_SESS"] = "MD5-sess";
  Algorithm["SHA_256"] = "SHA-256";
  Algorithm["SHA_256_SESS"] = "SHA-256-sess";
  Algorithm["SHA_512_256"] = "SHA-512-256";
  Algorithm["SHA_512_256_SESS"] = "SHA-512-256-sess";
  return Algorithm;
}({});
var algorithmList = Object.values(Algorithm);
var AlgorithmOptions = algorithmList.map(function (item) {
  return {
    value: item,
    label: item
  };
});
var OAuth2RequestParamSendAsKey = /*#__PURE__*/function (OAuth2RequestParamSendAsKey) {
  OAuth2RequestParamSendAsKey["REQUEST_URL"] = "request_url";
  OAuth2RequestParamSendAsKey["REQUEST_HEADER"] = "request_header";
  OAuth2RequestParamSendAsKey["REQUEST_BODY"] = "request_body";
  return OAuth2RequestParamSendAsKey;
}({});
var OAuth2CodeChallengeAlgorithm = /*#__PURE__*/function (OAuth2CodeChallengeAlgorithm) {
  OAuth2CodeChallengeAlgorithm["SHA256"] = "S256";
  OAuth2CodeChallengeAlgorithm["PLAIN"] = "plain";
  return OAuth2CodeChallengeAlgorithm;
}({});
var oAuth2CodeChallengeAlgorithmLabels = _defineProperty(_defineProperty({}, OAuth2CodeChallengeAlgorithm.SHA256, 'SHA-256'), OAuth2CodeChallengeAlgorithm.PLAIN, 'Plain');
var oAuth2CodeChallengeAlgorithmDefaultValue = OAuth2CodeChallengeAlgorithm.SHA256;
var oAuth2CodeChallengeAlgorithmOptions = Object.keys(oAuth2CodeChallengeAlgorithmLabels).map(function (key) {
  return {
    value: key,
    label: oAuth2CodeChallengeAlgorithmLabels[key]
  };
});
var OAuth2AddTokenTo = /*#__PURE__*/function (OAuth2AddTokenTo) {
  OAuth2AddTokenTo["HEADER"] = "header";
  OAuth2AddTokenTo["QUERY_PARAMS"] = "queryParams";
  return OAuth2AddTokenTo;
}({});
var oAuth2AddTokenToLabels = _defineProperty(_defineProperty({}, OAuth2AddTokenTo.HEADER, 'Header'), OAuth2AddTokenTo.QUERY_PARAMS, 'Query Params');
var oAuth2AddTokenToDefaultValue = OAuth2AddTokenTo.HEADER;
var oAuth2AddTokenToOptions = Object.keys(oAuth2AddTokenToLabels).map(function (key) {
  return {
    value: key,
    label: oAuth2AddTokenToLabels[key]
  };
});
var SignatureMethod = /*#__PURE__*/function (SignatureMethod) {
  SignatureMethod["HMAC_SHA1"] = "HMAC-SHA1";
  SignatureMethod["HMAC_SHA256"] = "HMAC-SHA256";
  SignatureMethod["HMAC_SHA512"] = "HMAC-SHA512";
  SignatureMethod["RSA_SHA1"] = "RSA-SHA1";
  SignatureMethod["RSA_SHA256"] = "RSA-SHA256";
  SignatureMethod["RSA_SHA512"] = "RSA-SHA512";
  SignatureMethod["PLAINTEXT"] = "PLAINTEXT";
  return SignatureMethod;
}({});
var signatureMethodList = Object.values(SignatureMethod);
var signatureMethodOptions = signatureMethodList.map(function (item) {
  return {
    value: item,
    label: item
  };
});
var OAuth2GrantType = /*#__PURE__*/function (OAuth2GrantType) {
  OAuth2GrantType["AUTHORIZATION_CODE"] = "authorization_code";
  OAuth2GrantType["AUTHORIZATION_CODE_WITH_PKCE"] = "authorization_code_with_pkce";
  OAuth2GrantType["IMPLICIT"] = "implicit";
  OAuth2GrantType["PASSWORD_CREDENTIALS"] = "password_credentials";
  OAuth2GrantType["CLIENT_CREDENTIALS"] = "client_credentials";
  return OAuth2GrantType;
}({});
var oAuth2GrantTypeLabels = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, OAuth2GrantType.AUTHORIZATION_CODE, 'Authorization Code'), OAuth2GrantType.AUTHORIZATION_CODE_WITH_PKCE, 'Authorization Code (With PKCE)'), OAuth2GrantType.IMPLICIT, 'Implicit'), OAuth2GrantType.PASSWORD_CREDENTIALS, 'Password Credentials'), OAuth2GrantType.CLIENT_CREDENTIALS, 'Client Credentials');
var oAuth2GrantTypeOptions = Object.keys(oAuth2GrantTypeLabels).map(function (key) {
  return {
    value: key,
    label: oAuth2GrantTypeLabels[key]
  };
});
var oAuth2GrantTypeDefaultValue = OAuth2GrantType.AUTHORIZATION_CODE;
var OAuth2ClientAuthentication = /*#__PURE__*/function (OAuth2ClientAuthentication) {
  OAuth2ClientAuthentication["BODY"] = "body";
  OAuth2ClientAuthentication["HEADER"] = "header";
  return OAuth2ClientAuthentication;
}({});
var oAuth2QueryParamNameDefaultValue = 'access_token';
var oAuth2HeaderKeyDefaultValue = 'Authorization';
var oAuth2ClientAuthenticationLabels = _defineProperty(_defineProperty({}, OAuth2ClientAuthentication.HEADER, 'Send as Basic Auth header'), OAuth2ClientAuthentication.BODY, 'Send client credentials in body');
var oAuth2ClientAuthenticationDefaultValue = OAuth2ClientAuthentication.HEADER;
var oAuth2ClientAuthenticationOptions = Object.keys(oAuth2ClientAuthenticationLabels).map(function (key) {
  return {
    value: key,
    label: oAuth2ClientAuthenticationLabels[key]
  };
});
var OAuth2UseTokenType = /*#__PURE__*/function (OAuth2UseTokenType) {
  OAuth2UseTokenType["ACCESS_TOKEN"] = "access_token";
  OAuth2UseTokenType["ID_TOKEN"] = "id_token";
  return OAuth2UseTokenType;
}({});
var oAuth2UseTokenTypeDefaultValue = OAuth2UseTokenType.ACCESS_TOKEN;
var oAuth2UseTokenTypeLabels = _defineProperty(_defineProperty({}, OAuth2UseTokenType.ACCESS_TOKEN, 'Access token'), OAuth2UseTokenType.ID_TOKEN, 'ID token');
var oAuth2UseTokenTypeOptions = Object.keys(oAuth2UseTokenTypeLabels).map(function (key) {
  return {
    value: key,
    label: oAuth2UseTokenTypeLabels[key]
  };
});
var HawkAlgorithm = /*#__PURE__*/function (HawkAlgorithm) {
  HawkAlgorithm["sha256"] = "sha256";
  HawkAlgorithm["sha1"] = "sha1";
  return HawkAlgorithm;
}({});
var HawkAlgorithmList = Object.values(HawkAlgorithm);
var OAuth2FlowsType = /*#__PURE__*/function (OAuth2FlowsType) {
  OAuth2FlowsType["AUTHORIZATION_CODE"] = "authorizationCode";
  OAuth2FlowsType["CLIENT_CREDENTIALS"] = "clientCredentials";
  OAuth2FlowsType["IMPLICIT"] = "implicit";
  OAuth2FlowsType["PASSWORD"] = "password";
  return OAuth2FlowsType;
}({});
var oAuth2FlowsNames = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, OAuth2FlowsType.AUTHORIZATION_CODE, 'Authorization Code'), OAuth2FlowsType.CLIENT_CREDENTIALS, 'Client Credentials'), OAuth2FlowsType.IMPLICIT, 'Implicit'), OAuth2FlowsType.PASSWORD, 'Password');
exports.Algorithm = Algorithm;
exports.AlgorithmOptions = AlgorithmOptions;
exports.AuthLabelMap = AuthLabelMap;
exports.AuthOptionList = AuthOptionList;
exports.AuthTypeItemLabelMap = AuthTypeItemLabelMap;
exports.AuthValue = AuthValue;
exports.AuthValueList = AuthValueList;
exports.AuthValueMap = AuthValueMap;
exports.HawkAlgorithm = HawkAlgorithm;
exports.HawkAlgorithmList = HawkAlgorithmList;
exports.InheritAuthOption = InheritAuthOption;
exports.LegacySecuritySchemeAuthType = LegacySecuritySchemeAuthType;
exports.OAuth2AddTokenTo = OAuth2AddTokenTo;
exports.OAuth2ClientAuthentication = OAuth2ClientAuthentication;
exports.OAuth2CodeChallengeAlgorithm = OAuth2CodeChallengeAlgorithm;
exports.OAuth2FlowsType = OAuth2FlowsType;
exports.OAuth2GrantType = OAuth2GrantType;
exports.OAuth2RequestParamSendAsKey = OAuth2RequestParamSendAsKey;
exports.OAuth2UseTokenType = OAuth2UseTokenType;
exports.SignatureMethod = SignatureMethod;
exports.defaultAuth = defaultAuth;
exports.oAuth2AddTokenToDefaultValue = oAuth2AddTokenToDefaultValue;
exports.oAuth2AddTokenToLabels = oAuth2AddTokenToLabels;
exports.oAuth2AddTokenToOptions = oAuth2AddTokenToOptions;
exports.oAuth2ClientAuthenticationDefaultValue = oAuth2ClientAuthenticationDefaultValue;
exports.oAuth2ClientAuthenticationLabels = oAuth2ClientAuthenticationLabels;
exports.oAuth2ClientAuthenticationOptions = oAuth2ClientAuthenticationOptions;
exports.oAuth2CodeChallengeAlgorithmDefaultValue = oAuth2CodeChallengeAlgorithmDefaultValue;
exports.oAuth2CodeChallengeAlgorithmLabels = oAuth2CodeChallengeAlgorithmLabels;
exports.oAuth2CodeChallengeAlgorithmOptions = oAuth2CodeChallengeAlgorithmOptions;
exports.oAuth2FlowsNames = oAuth2FlowsNames;
exports.oAuth2GrantTypeDefaultValue = oAuth2GrantTypeDefaultValue;
exports.oAuth2GrantTypeLabels = oAuth2GrantTypeLabels;
exports.oAuth2GrantTypeOptions = oAuth2GrantTypeOptions;
exports.oAuth2HeaderKeyDefaultValue = oAuth2HeaderKeyDefaultValue;
exports.oAuth2QueryParamNameDefaultValue = oAuth2QueryParamNameDefaultValue;
exports.oAuth2UseTokenTypeDefaultValue = oAuth2UseTokenTypeDefaultValue;
exports.oAuth2UseTokenTypeLabels = oAuth2UseTokenTypeLabels;
exports.oAuth2UseTokenTypeOptions = oAuth2UseTokenTypeOptions;
exports.signatureMethodList = signatureMethodList;
exports.signatureMethodOptions = signatureMethodOptions;
